import SpinnerButton from './SpinnerButton';

export default SpinnerButton;
